import React from 'react';

const LoaderFull = () => {
  return (
    <div className="loader">
      <div className="center">
        <div className="loader">
          <i className="fa fa-spin fa-2x fa-spinner" />
        </div>
      </div>
    </div>
  );
};

export default LoaderFull;



// WEBPACK FOOTER //
// src/components/layout/Loader.js